import React from 'react'
import injectSheet from 'react-jss'
import ReactHtmlParser from 'html-react-parser'
import style from './style'

/**
 * A sidebar menu that contains routes to different paths, overlays on mobile. NOTE: requires react-router-redux
 */

export const Footer = props => {
  const { classes, contact, copyright, isMenuToggled } = props
  const { base, hideOnMobile, content } = classes

  const className = isMenuToggled ? `${base}` : `${base} ${hideOnMobile}`

  return (
    <div className={`${className} menu-footer`}>
      <div className={content}>
        {contact && (
          <a href={`mailto:${contact.address}?subject=Hi%20Team`}>
            {ReactHtmlParser(contact.msg)}
          </a>
        )}
        <div className={classes.copyright}>{ReactHtmlParser(copyright)}</div>
      </div>
    </div>
  )
}

const styleAndTheme = theme => style

export default injectSheet(styleAndTheme)(Footer)
